import { render, staticRenderFns } from "./DebtRemovalModal.vue?vue&type=template&id=206f90bd&scoped=true&"
import script from "./DebtRemovalModal.vue?vue&type=script&lang=js&"
export * from "./DebtRemovalModal.vue?vue&type=script&lang=js&"
import style0 from "./DebtRemovalModal.vue?vue&type=style&index=0&id=206f90bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206f90bd",
  null
  
)

component.options.__file = "DebtRemovalModal.vue"
export default component.exports